import eventBus from '@/events/eventBus';


/**
 * 点击记录事件
 * @param itemObj
 */
export function onFlushSelArea(backFun) {
  eventBus.off('onFlushSelArea');
  eventBus.on('onFlushSelArea', ( options) => {
    backFun && backFun(options);
  });
}


/**
 * 点击记录事件
 * @param itemObj
 */
export function executeFlushSelArea(options) {
  eventBus.emit('onFlushSelArea', options);
}
/**
 * 触发tab点击事件
 * @param tabItem
 */
export function emitTabClickEvent(tabItem) {
  eventBus.emit('mainPageTabClickEvent', { tabItem });
}

/**
 * 注册tab点击事件
 * @param backFun
 */
export function onTabClickEvent(backFun: Function) {
  //销毁以前的事件
  eventBus.off('mainPageTabClickEvent');
  eventBus.on('mainPageTabClickEvent', ({ tabItem }) => {
    backFun && backFun({ tabItem });
  });
}

/**
 * 注册右侧元素明细事件
 * @param backFun
 */
export function onRightDetailEvent(backFun: Function) {
  //销毁以前的事件
  eventBus.off('onRightDetailEvent');
  eventBus.on('onRightDetailEvent', ({ item, title, rightFormConfig }) => {
    backFun && backFun({ item, title, rightFormConfig });
  });
}

/**
 * 触发打开右侧明细信息
 * @param item
 * @param title
 * @param rightFormConfig
 */
export function emitRightDetailEvent({ item, title, rightFormConfig }) {
  eventBus.emit('onRightDetailEvent', { item, title, rightFormConfig });
}
/**
 * 注册控件选中事件
 * @param backFun
 */
export function onItemSelEvent(backFun) {
  eventBus.off('executeItemSelEvent');
  eventBus.on('executeItemSelEvent', ({ item }) => {
    backFun && backFun({ item });
  });
}

/**
 * 执行控件选中事件
 * @param item
 */
export function executeItemSelEvent({ item }) {
  eventBus.emit('executeItemSelEvent', { item });
}


/**
 * 执行事件
 * @param pageDes
 */
export function executeSaveEvent(publicFlag: boolean, backFun?: any,pageType?:any) {
  eventBus.emit('saveDesInfo', { backFun, publicFlag,pageType });
}



/**
 * 执行打开deatilPanel
 */
export function executeEditorPanelEvent({ panedDetail, title, formConfig }) {
  eventBus.emit('openPanelDetail', { panedDetail, title, formConfig });
}

/**
 * 执行关闭deatilPanel的命令
 */
export function emitCloseEditorPanelEvent() {
  eventBus.emit('closePanelDetail', {});
}

/**
 * 注册detailPanel显示事件
 * @param state
 */
export function initDetailPanelEvent(leftDetailFlag: any, backFun: Function) {
  eventBus.off('openPanelDetail');
  eventBus.on('openPanelDetail', ({ panedDetail, title, formConfig }) => {
    leftDetailFlag.value = true;
    backFun && backFun({ panedDetail, title, formConfig });
  });

  eventBus.off('closePanelDetail');
  eventBus.on('closePanelDetail', () => {
    leftDetailFlag.value = false;
  });
}

export function formElOnMounted(item) {
  eventBus.emit('formElOnMounted', { item });
}

/**
 * 改变栏目组件事件
 * @param backFun
 */
export function onClearEvent(backFun) {
  eventBus.off('onClearEvent');
  eventBus.on('onClearEvent', () => {
    backFun && backFun();
  });
}

/**
 * 调用栏目组件切换事件
 * @param itemObj
 */
export function executeClearEvent() {
  eventBus.emit('onClearEvent', {});
}

/**
 * 注册界面切换事件
 * @param backFun
 */
export function onPageChange(backFun) {
  eventBus.off('executePageChange');
  eventBus.on('executePageChange', ({ pageId }) => {
    backFun && backFun({ pageId });
  });
}
/**
 * 调用栏目组件切换事件
 * @param itemObj
 */
export function executePageChange({ pageId }) {
  eventBus.emit('executePageChange', { pageId });
}

/**
 * 注册打开数据源配置
 * @param backFun
 */
export function onOpenDsConfigEvent(backFun) {
  eventBus.off('executeOpenDsConfig');
  eventBus.on('executeOpenDsConfig', ({ content }) => {
    backFun && backFun({ content });
  });
}

/**
 * 注册打开数据源配置
 */
export function executeOpenDsConfig({ content }) {
  eventBus.emit('executeOpenDsConfig', { content });
}

/**
 * 注册打开数据源配置
 * @param backFun
 */
export function onDsSetEvent(backFun) {
  eventBus.off('executeDsSet');
  eventBus.on('executeDsSet', ({ content, clear }) => {
    backFun && backFun({ content, clear });
  });
}

/**
 * 注册打开数据源配置
 */
export function executeDsSet({ content, clear = false }) {
  eventBus.emit('executeDsSet', { content, clear });
}

/**
 * 注册关闭窗口
 * @param backFun
 */
export function onCloseDesWinEvent(backFun) {
  eventBus.off('executeCloseDesWin');
  eventBus.on('executeCloseDesWin', () => {
    backFun && backFun();
  });
}

/**
 * 关闭设计窗口
 */
export function executeCloseDesWin() {
  eventBus.emit('executeCloseDesWin', {});
}

/**
 * 注册 获取节点出参信息
 * @param backFun
 */
export function onNodeOutParamsEvent(backFun) {
  eventBus.off('executeNodeOutParamsEvent');
  eventBus.on('executeNodeOutParamsEvent', (options) => {
    backFun && backFun(options);
  });
}

/**
 * 关闭设计窗口
 */
export function executeNodeOutParamsEvent(options) {
  eventBus.emit('executeNodeOutParamsEvent', { options });
}

/**
 * 注册 刷新版本事件
 * @param backFun
 */
export function onFlushVerEvent(backFun) {
  eventBus.off('executeFlushVerEvent');
  eventBus.on('executeFlushVerEvent', (options) => {
    backFun && backFun(options);
  });
}




/**
 * 点击记录事件
 * @param itemObj
 */
export function onCurElClick(backFun) {
  eventBus.off('onCurElClick');
  eventBus.on('onCurElClick', ( options) => {
    backFun && backFun(options);
  });
}


/**
 * 点击记录事件
 * @param itemObj
 */
export function executeElClick(options) {
  eventBus.emit('onCurElClick', options);
}


export interface ICurElConfig{
  curItemObj:any,
  domEl:any,
  list:any,
  curElIndex:number,
  borderConfig?:any,
}
/**
 * 刷新激活元素的选中状态信息
 * @param itemObj
 */
export function onFlushActiveState(backFun) {
  eventBus.off('onFlushActiveState');
  eventBus.on('onFlushActiveState', ( options) => {
    backFun && backFun(options);
  });
}

export function executeFlushActiveState() {
  eventBus.emit('onFlushActiveState', {});
}

export function onHideActiveState(backFun) {
  eventBus.off('onHideActiveState');
  eventBus.on('onHideActiveState', ( options) => {
    backFun && backFun(options);
  });
}

export function executeHideActiveState() {
  eventBus.emit('onHideActiveState', {});
}
